import axios from 'axios';

const host = process.env.VUE_APP_URL_API;

export default class ValidRegister {
  doValidRegister(programId, data) {
    this.path = `/checkout/${programId}/pre-registration`;
    this.url = host + this.path;
    return axios.post(this.url, data);
  }
}
